<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 10C15 9.33696 15.2634 8.70107 15.7322 8.23223C16.2011 7.76339 16.837 7.5 17.5 7.5C18.163 7.5 18.7989 7.76339 19.2678 8.23223C19.7366 8.70107 20 9.33696 20 10C20 10.663 19.7366 11.2989 19.2678 11.7678C18.7989 12.2366 18.163 12.5 17.5 12.5C16.837 12.5 16.2011 12.2366 15.7322 11.7678C15.2634 11.2989 15 10.663 15 10ZM7.5 10C7.5 9.33696 7.76339 8.70107 8.23223 8.23223C8.70107 7.76339 9.33696 7.5 10 7.5C10.663 7.5 11.2989 7.76339 11.7678 8.23223C12.2366 8.70107 12.5 9.33696 12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.2366 8.23223 11.7678C7.76339 11.2989 7.5 10.663 7.5 10ZM0 10C0 9.33696 0.263392 8.70107 0.732233 8.23223C1.20107 7.76339 1.83696 7.5 2.5 7.5C3.16304 7.5 3.79893 7.76339 4.26777 8.23223C4.73661 8.70107 5 9.33696 5 10C5 10.663 4.73661 11.2989 4.26777 11.7678C3.79893 12.2366 3.16304 12.5 2.5 12.5C1.83696 12.5 1.20107 12.2366 0.732233 11.7678C0.263392 11.2989 0 10.663 0 10Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconCard",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 5,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
